import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CalendarDays } from "lucide-react";
import { SiteHeader, SiteFooter, PageHero } from "./SiteLayout";
import { useSiteContent, usePageMeta } from "./siteContent";

const fmtDate = (d) => {
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
};

export default function SiteBlog() {
  const site = useSiteContent();
  usePageMeta("News & Updates | Wales Event Medical Services",
    "Stories, event round-ups and advice from the Wales Event Medical Services team.", "", "blog");
  const bs = site.blog_settings || {};
  const [posts, setPosts] = useState(null);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site/blog`)
      .then((r) => (r.ok ? r.json() : []))
      .then((d) => setPosts(Array.isArray(d) ? d : []))
      .catch(() => setPosts([]));
  }, []);
  return (
    <div className="site-font bg-[#0B0F14]" data-testid="site-blog">
      <SiteHeader />
      <PageHero title={bs.title || "Blog"} subtitle={bs.subtitle || ""} image={bs.image || "/site-assets/hero6.jpg"} />
      <section className="py-20 bg-[#0B0F14]">
        <div className="container-x">
          {!posts ? (
            <p className="text-center text-slate-400 text-sm">Loading…</p>
          ) : posts.length === 0 ? (
            <div className="text-center max-w-md mx-auto" data-testid="blog-empty">
              <h2 className="section-title">No posts yet</h2>
              <p className="mt-3 text-slate-300">Check back soon — news and updates from the team will appear here.</p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {posts.map((p, i) => (
                <Link key={p.id} to={`/blog/${p.slug}`} className="group card-soft overflow-hidden hover:shadow-xl transition-shadow duration-300" data-testid={`blog-card-${i}`}>
                  {p.cover_image && (
                    <div className="h-52 overflow-hidden">
                      <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    </div>
                  )}
                  <div className="p-6">
                    <p className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#00D2C2]">
                      <CalendarDays size={14} /> {fmtDate(p.published_at)}
                    </p>
                    <h2 className="mt-2 font-serif-site text-xl font-bold text-white group-hover:text-[#00D2C2] transition-colors">{p.title}</h2>
                    {p.excerpt && <p className="mt-2 text-sm text-slate-300 leading-relaxed line-clamp-3">{p.excerpt}</p>}
                    <span className="mt-4 inline-flex items-center gap-2 text-[#00D2C2] font-semibold text-sm group-hover:gap-3 transition-all">
                      Read more <ArrowRight size={16} />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
